export default __webpack_public_path__ + "static/media/ste_clothilde_church.1231cc6a.jpg";